var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.4002,
    y: 18.4,
    width: 16.8,
    height: 16.8,
    rx: 8.4,
    transform: "rotate(-180 18.4002 18.4)",
    fill: "white",
    stroke: "#F0F0F0",
    strokeWidth: 2.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9998 17.2C13.9763 17.2 17.1998 13.9765 17.1998 10C17.1998 6.0236 13.9763 2.80005 9.9998 2.80005C6.02335 2.80005 2.7998 6.0236 2.7998 10C2.7998 13.9765 6.02335 17.2 9.9998 17.2Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28917 5.61646C3.7236 6.35229 3.29714 7.2004 3.04883 8.12175H6.79446L4.28917 5.61646Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9526 8.12172C16.7043 7.2004 16.2778 6.35229 15.7123 5.61646L13.207 8.12172H16.9526Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04883 11.8784C3.29717 12.7997 3.72363 13.6478 4.28917 14.3837L6.79438 11.8784H3.04883Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3842 4.28846C13.6483 3.7229 12.8003 3.29644 11.8789 3.0481V6.7937L14.3842 4.28846Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61719 15.7117C6.35302 16.2773 7.20113 16.7038 8.12245 16.9521V13.2065L5.61719 15.7117Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12242 3.0481C7.2011 3.29644 6.35299 3.7229 5.61719 4.28844L8.12242 6.79367V3.0481Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8789 16.9521C12.8002 16.7038 13.6483 16.2773 14.3841 15.7118L11.8789 13.2065V16.9521Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.207 11.8784L15.7123 14.3837C16.2778 13.6479 16.7043 12.7997 16.9526 11.8784H13.207Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1389 9.06093H10.939H10.939V2.861C10.6315 2.82097 10.3181 2.80005 9.9998 2.80005C9.68146 2.80005 9.36809 2.82097 9.06068 2.861V9.06087V9.0609H2.86075C2.82073 9.36833 2.7998 9.68176 2.7998 10C2.7998 10.3184 2.82073 10.6318 2.86075 10.9392H9.06063H9.06065V17.1391C9.36809 17.1791 9.68146 17.2 9.9998 17.2C10.3181 17.2 10.6315 17.1792 10.9389 17.1391V10.9392V10.9392H17.1389C17.1789 10.6318 17.1998 10.3184 17.1998 10C17.1998 9.68176 17.1789 9.36833 17.1389 9.06093Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8779 11.8782L15.0908 15.0911C15.2386 14.9434 15.3795 14.7889 15.514 14.6289L12.7634 11.8782H11.8779V11.8782Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1221 11.8784H8.12204L4.90918 15.0913C5.05689 15.239 5.21133 15.38 5.37141 15.5145L8.1221 12.7638V11.8784Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12146 8.12191V8.12185L4.90858 4.90894C4.76081 5.05665 4.61985 5.21108 4.48535 5.37117L7.23606 8.12188H8.12146V8.12191Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8779 8.12174L15.0908 4.90879C14.9431 4.76102 14.7887 4.62006 14.6286 4.4856L11.8779 7.23631V8.12174Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(2.7998 2.80005)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.48fe7cedb3a0b9be8af195d5327d8542.svg";
export { ForwardRef as ReactComponent };